import CreateApiModule from "@/redux/create-api-module";
import { Config } from "@/utils/config.utils";

import { $ShopNamesModuleName } from "./shopNames.types";

const { actions } = CreateApiModule(
    $ShopNamesModuleName,
    () => `/storeservice/${Config.general.basestore}/localized/stores/shopnames`
);

export const clear = actions.clear;
export const load = actions.load;
export const refetch = actions.refetch;
